import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import determineIfMobile from '@homeaway/react-determine-if-mobile';
import {TrackingContext} from '@homeaway/react-event-tracking';

import {CardCarousel} from '../carousel/Carousel';
import {ReviewsLoader} from './ReviewsLoader';
import Review from './Review';
import EdapViewTracker from '../edap-view-tracker/EdapViewTracker';
import {reactCarouselBreakPoints} from '../../../utils/carousel-breakpoints';
import './style.less';
import {selector} from '../../../utils/wdio-selectors';

const ACTION_LOCATION = 'property-reviews';

export class ReviewsComponent extends Component {
    constructor(props) {
        super(props);

        this.fetchedData = false;
    }

    static contextType = TrackingContext;

    handleNext = () => {
        this.context.trigger('nav.next.click');
    };

    handlePrev = () => {
        this.context.trigger('nav.previous.click');
    };

    renderReviewsComponent() {
        const {
            aspectRatio = '4x3',
            baseCls = 'reviews',
            dispatch,
            tripboardComponent,
            expandedTripboardButton,
            isMobile,
            reviews,
            simpleName,
            text = {},
            showNewHeadings,
        } = this.props;

        const {title = '', subtitle = ''} = text;

        const breakPoints = {
            1600: 4,
            1200: 3,
            992: 3,
            768: 2,
            480: 2,
            0: isMobile ? 2 : 4,
        };

        return (
            <div
                className={`container module module--no-padding ${baseCls}`}
                data-wdio={selector.reviews}
            >
                {showNewHeadings && (
                    <h3 className="page-subheading heading--with-padding">
                        {title}
                    </h3>
                )}
                <CardCarousel
                    aspectRatio={aspectRatio}
                    breakpoints={reactCarouselBreakPoints(
                        isMobile,
                        breakPoints
                    )}
                    titleMessage={showNewHeadings ? null : title}
                    subtitleMessage={subtitle}
                    onNextClick={this.handleNext}
                    onPreviousClick={this.handlePrev}
                >
                    {reviews.map((reviewItem, i) => (
                        <Review
                            key={i}
                            {...{
                                tripboardComponent,
                                simpleName,
                                ...reviewItem,
                                ...{
                                    baseCls: `${baseCls}-review`,
                                    dispatch,
                                    expandedTripboardButton,
                                    isMobile,
                                    position: i + 1,
                                },
                            }}
                        />
                    ))}
                </CardCarousel>
                <EdapViewTracker
                    eventData={{actionlocation: ACTION_LOCATION}}
                />
            </div>
        );
    }

    render() {
        const {reviews} = this.props;

        if (!Array.isArray(reviews) && !this.fetchedData) {
            this.fetchedData = true;
            return <ReviewsLoader />;
        }

        // If no reviews were returned, e.g. because of a service error, don't render the component
        if (!reviews.length) {
            return null;
        }

        return this.renderReviewsComponent();
    }
}

export function mapStateToProps(state) {
    const {
        options = {},
        destination: {details = {}, reviews = {}} = {},
        modules: {pageHeadings = {}} = {},
    } = state;

    return {
        expandedTripboardButton: options.expandedTripboardButton,
        reviews: reviews.items,
        simpleName: details.simpleName,
        text: reviews.text,
        showNewHeadings: pageHeadings.showNewHeadings,
    };
}

export const Reviews = connect(mapStateToProps)(
    determineIfMobile(ReviewsComponent)
);

Reviews.displayName = 'Reviews';

ReviewsComponent.contextTypes = {
    trigger: PropTypes.func,
};

export default Reviews;
